<template>
  <v-container class="pa-0">
    <v-card
      :loading="isLoading"
    >
      <v-card-title>
        {{ jackpot.name }} Jackpot History
        <v-btn
          class="ml-auto"
          icon
          @click="$emit('close')"
        >
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-container>
        <v-card>
          <v-row class="mx-0">
            <v-col
              class="d-flex align-center"
              style="gap: 0.5rem;"
              cols="6"
            >
              <date-picker
                v-model="from"
                label="From"
              />
              -
              <date-picker
                v-model="to"
                label="End"
              />
            </v-col>
            <v-col
              v-if="history.length"
              cols="6"
            >
              <export
                class="justify-end"
                :data="history"
                :report-name="`jackpot-${jackpot.jackpot_id}-history-${Date.now()}`"
                :fields="Object.keys(history[0])"
                without_sg
              />
            </v-col>
          </v-row>

          <v-simple-table>
            <thead>
              <tr>
                <th>
                  ID
                </th>
                <th>
                  Login
                </th>
                <th>
                  Draw date
                </th>
                <th>
                  Project
                </th>
                <th>
                  Original Amount
                </th>
                <th>
                  Reward Amount, €
                </th>
                <th>
                  Bet ID
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!history.length && !isLoading">
                <td
                  class="text-center"
                  colspan="6"
                >
                  No data found
                </td>
              </tr>
              <tr
                v-for="entry in history"
                :key="entry.prizepool_id"
              >
                <td>
                  <a
                    v-if="!!entry.login"
                    :href="'/user-management/' + entry.login"
                    target="_blank"
                  >
                    {{ entry.account_id }}
                  </a>
                </td>
                <td>
                  <a
                    v-if="!!entry.login"
                    :href="'/user-management/' + entry.login"
                    target="_blank"
                  >
                    {{ entry.login }}
                  </a>
                </td>
                <td v-text="entry.date" />
                <td v-text="entry.entity" />
                <td v-text="[entry.amount, entry.currency ?? ''].join(' ').trim()" />
                <td v-text="entry.amount_in_eur" />
                <td>
                  {{ entry.bet_id }}
                  <v-btn
                    v-if="entry.status === STATUS_FAILED && canEdit"
                    class="ml-2"
                    icon
                    color="warning"
                    :loading="isLoading"
                    @click="$emit('re-issue', entry)"
                  >
                    <v-icon>
                      mdi-alert
                    </v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import moment from 'moment'
import DatePicker from '@/components/core/DatePicker/DatePicker.vue'

export default {
  props: {
    isLoading: Boolean,
    history: {
      type: Array,
      required: true,
    },
    jackpot: {
      type: Object,
      required: true,
    },
    canEdit: Boolean,
  },
  emits: ['show-history', 'close', 're-issue'],
  data() {
    return {
      from: moment(this.jackpot.start).format('YYYY-MM-DD'),
      to: moment(this.jackpot.end).format('YYYY-MM-DD'),
      STATUS_FAILED: 'failed',
    }
  },
  components: {
    Export: () => import('@/components/helper/Export'),
    DatePicker,
  },

  computed: {
    dateWatchTarget() {
      return this.from + this.to
    },
  },

  watch: {
    dateWatchTarget() {
      this.$emit('show-history', {
        from: this.from,
        to: this.to,
      })
    }
  },
}
</script>
